var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"demand_new\"\u003E\u003Cdemand-form :errors=\"errors\" @submit=\"createDemand\"\u003E\u003C\u002Fdemand-form\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;